import { Partner } from "./partners";

export enum PartnerBonusType {
  BONUS_BET = "BONUS_BET",
  BONUS_SETTELMENT = "BONUS_SETTELMENT",
  BONUS_DEPOSIT = "BONUS_DEPOSIT",
  BONUS_REGISTRATION = "BONUS_REGISTRATION",
  BONUS_WITH_CODE = "isBonusWithCode",
  BONUS_REFERRAL = "REFERRAL"
};

export interface PartnerBonus {
  id: number;
  dtCreated: string | null;
  dtUpdated: string | null;
  dtEndTime: string | null;
  dtStartTime: string | null;
  description: string;
  type: PartnerBonusType;
  partnerInfo: Partner[];
  statut: string;
  strWhoCreated: string | null;
  strWhoUpdated: string | null;
  dbMaxGainPerPlayerPerDay: number;
  dbMaxCountGainPerPlayerPerDay: number;
  dbmaxgainperplayerperPromotion: number;
  dbmaxcountgainperplayerperPromotion: number;
  bonusId: number | null;
  bcheckPeriod: boolean;
  bstakeDeduction: boolean;
  bpartialStake: boolean;
  bbonusAccumulator: boolean;
  ballowCashout: boolean;
  tbonusPackageCustomizeList: Array<BonusPackageCustomizeList>;
}

export interface BonusPackageCustomizeList {
  bonusCustomizedId: number | null;
  dtCreated: string | null;
  dtUpdated: string | null;
  id: number | null;
  statut: null | string;
  strWhoCreated: string | null;
  strWhoUpdated: string | null;
  packageCustomizeId: PackageCustomizeId | null;
}

export interface PackageCustomizeId {
  dbDaylyMaxAmount: number;
  dbEarningsCeiling: number;
  dbMaxAmount: number;
  dtCreated: string | null;
  dtUpdated: string | null;
  id: number;
  intDaylyPeriod: number;
  intMaxActiveBonus: number;
  intvalidityperiod: number;
  name: string;
  packageRuleCustomizeId: {
    awardBonusAtEndDate: boolean;
    code: string;
    dbDaylyMaxBonusAmount: number;
    dbFlatAmount: number;
    dbFlatPercentage: number;
    dbRollover: number;
    dtCreated: string | null;
    dtUpdated: string | null;
    id: number;
    rolloverExpression: string;
    ruleName: string;
    ruleTypeKey: string;
    strWhoCreated: string | null;
    strWhoUpdated: string | null;
  };
  statut: string;
  strProductType: string;
  strWhoCreated: string | null;
  strWhoUpdated: string | null;
}
